<template>
  <a-table
    :columns="columns"
    :data-source="list"
    bordered
    rowKey="id"
    :pagination="false"
    :loading="loading"
    size="small"
  >
    <!-- 用户ID -->
    <template slot="userId" slot-scope="text, record">
      <div class="g-table-text">
        <a-icon
          type="copy"
          data-clipboard-action="copy"
          title="Copy"
          style="color:#ccc"
          :data-clipboard-text="`${text}`"
          :id="`logs_login_event_${record.id}`"
          @click="copyContent(`#logs_login_event_${record.id}`)"
        />{{ text }}
      </div>
    </template>

    <!-- 类型 -->
    <template slot="loginStatus" slot-scope="text">
      <span v-if="text === 0">Login</span>
      <span v-if="text === 1">Logout</span>
    </template>

    <!-- 成功与否 -->
    <template slot="success" slot-scope="text">
      <span v-if="text">{{ $t('com_msg_success') }}</span>
      <span v-else>{{ $t('com_msg_fail') }}</span>
    </template>

    <!-- 登录时间 -->
    <template slot="timeLogin" slot-scope="text">
      <span v-if="text">{{ text | formatDate }}</span>
      <span v-else>--</span>
    </template>

    <!-- 登出时间 -->
    <template slot="timeLogout" slot-scope="text">
      <span v-if="text">{{ text | formatDate }}</span>
      <span v-else>--</span>
    </template>

    <!-- 登出原因  -->
    <template slot="logoutReason" slot-scope="text">
      <!-- 登出原因，0-认证失败拒绝，1-用户主动logout，2-用户断网超时退出，3-用户信息更新系统强制重新登录 -->
      <span v-if="$t('logs_logout_reason')[text]">
        {{ $t('logs_logout_reason')[text] }}
      </span>
      <span v-else>--</span>
    </template>

    <!-- 属地 -->
    <template slot="Location" slot-scope="text">
      {{ text | location }}
    </template>
  </a-table>
</template>
<script>
import { copyContent } from '@/libs/utils';

export default {
  props: {
    list: {
      type: [Array, Object],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      copyContent,
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },

        {
          title: this.$t('logs_table_user_id'),
          dataIndex: 'userId',
          scopedSlots: { customRender: 'userId' },
        },

        {
          title: this.$t('logs_table_user_name'),
          dataIndex: 'userName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
          width: 170,
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('com_table_status'),
          dataIndex: 'loginStatus',
          align: 'center',
          scopedSlots: { customRender: 'loginStatus' },
        },

        {
          title: this.$t('logs_table_success'),
          dataIndex: 'success',
          align: 'center',
          scopedSlots: { customRender: 'success' },
        },

        {
          title: this.$t('logs_table_login_time'),
          dataIndex: 'timeLogin',
          scopedSlots: { customRender: 'timeLogin' },
        },

        {
          title: this.$t('logs_table_logout_time'),
          dataIndex: 'timeLogout',
          scopedSlots: { customRender: 'timeLogout' },
        },

        {
          title: this.$t('logs_table_logout_reason'),
          dataIndex: 'logoutReason',
          align: 'center',
          scopedSlots: { customRender: 'logoutReason' },
        },
      ],
    };
  },
};
</script>
